import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CreateMemberDto, MemberDto, TriageMemberDto, UpdateMemberDto } from '@shared/dto';
import { ApiOptions } from '@shared/interfaces/api-options.interface';
import {AbstractMemberService} from "./abstract-member.service";

@Injectable({
  providedIn: 'root'
})
export class MemberService extends AbstractMemberService<MemberDto, CreateMemberDto, UpdateMemberDto> {
  triage(dto: TriageMemberDto, params?: string | number | Record<string, string | number>, options?: ApiOptions): Observable<MemberDto> {
    const url: string = `${this.url(params)}`;
    return this.http.post<MemberDto>(url, dto, options).pipe(catchError(error => this.handleHttpErrorResponse(error)));
  }
}
